import * as React from 'react';
import './page-title.component.scss';

const PageTitle = ({ children, className }) => (
    <h2 className={`${className || ''} page-title`}>{children}</h2>
);

export default PageTitle;
